import { Snackbar as SnackbarMUI, Stack as StackMUI, styled } from '@mui/material';

export const Stack = styled(StackMUI)(() => ({
  position: 'absolute',
}));

export const Snackbar = styled(SnackbarMUI)(() => ({
  top: 24,
}));

export const CodeWrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 8,
}));
